export default __webpack_public_path__ + "static/shanthy-6ca96fbe30397e3a337f5ef942c6fb75.png";